export const PAID_COLUMN_HEADINGS = [
	'customFields-responses-table-fullName',
	'customFields-responses-table-seat',
	'customFields-responses-table-email',
	'customFields-responses-table-phone',
	'customFields-responses-table-date',
	'customFields-responses-table-amount',
	'customFields-responses-table-orderId',
	'customFields-responses-table-type',
	'customFields-responses-table-status',
	'customFields-responses-table-ticketTypes',
	'customFields-responses-table-scanned',
	'customFields-responses-table-promotion',
	'customFields-responses-table-giftCards',
	'customFields-responses-table-addons',
];

export const REGISTRATION_COLUMN_HEADINGS = [
	'customFields-responses-table-orderId',
	'customFields-responses-table-type',
	'customFields-responses-table-email',
	'customFields-responses-table-fullName',
	'customFields-responses-table-phone',
	'customFields-responses-table-date',
	'customFields-responses-table-ticketTypes',
	'customFields-responses-table-scanned',
	'customFields-responses-table-promotion',
	'customFields-responses-table-giftCards',
	'customFields-responses-table-seat',
];

// Width arrays are indexed positionally with the rendered column order.
//
// PAID order:
//   [fullName, seat, email, phone, date, amount, orderId, type, status, ticketTypes, scanned, promotion, giftCards, addons]
// REGISTRATION order:
//   [orderId, type, email, fullName, phone, date, ticketTypes, scanned, promotion, giftCards, addons, seat]
//
// Trailing entries cover the dynamic "responses" cell width (for the responses
// view, isAttendeesList=false) and the actions / QR fixed-width column.
export const PAID_COLUMN_MIN_WIDTH_HEADERS = [
	250, 100, 300, 160, 250, 120, 100, 150, 120, 250, 120, 180, 180, 180, 50, 80,
];
export const PAID_COLUMN_MIN_WIDTH = [250, 100, 300, 160, 250, 120, 100, 150, 120, 250, 120, 180, 180, 180, 50, 80];
export const PAID_COLUMN_MAX_WIDTH: (number | undefined)[] = [
	undefined,
	150,
	undefined,
	undefined,
	undefined,
	150,
	undefined,
	undefined,
	undefined,
	undefined,
	150,
	200,
	200,
	200,
	250,
	undefined,
	80,
];

export const REGISTRATION_COLUMN_MIN_WIDTH_HEADERS = [
	100, 150, 300, 250, 160, 250, 250, 120, 180, 180, 180, 250, 50, 80,
];
export const REGISTRATION_COLUMN_MIN_WIDTH = [100, 150, 300, 250, 160, 250, 250, 120, 180, 180, 180, 250, 50, 80];
export const REGISTRATION_COLUMN_MAX_WIDTH: (number | undefined)[] = [
	undefined,
	undefined,
	undefined,
	undefined,
	undefined,
	undefined,
	undefined,
	150,
	200,
	200,
	200,
	250,
	undefined,
	80,
];

// Back-compat aliases. The existing tests + non-paid code paths import these
// names; they default to the paid arrays so the new order is reflected
// everywhere it matters (the paid + attendee-list flow). Non-paid code paths
// should migrate to the REGISTRATION_* arrays via the helpers in utils.ts.
export const COLUMN_MIN_WIDTH_HEADERS = PAID_COLUMN_MIN_WIDTH_HEADERS;
export const COLUMN_MIN_WIDTH = PAID_COLUMN_MIN_WIDTH;
export const COLUMN_MAX_WIDTH = PAID_COLUMN_MAX_WIDTH;

export const BROWSER_TZ = Intl.DateTimeFormat().resolvedOptions().timeZone;

// Column index where dynamically-loaded custom-field response cells are inserted
// (used only when isAttendeesList=false; with isAttendeesList=true the responses
// are appended at the end).
export const RESPONSES_INDEX = 4;
